import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Observable } from 'rxjs';
import { DatePipe } from '@angular/common';
import { NewsModel } from '../../../models/centre/news.models';
import { Message } from '../../../models/centre/message.model'
import { NewMemoUrl } from '../../../shared/urls/newmemo.url';
import { BaseService } from '../../../shared/services/base.service';

@Injectable()
export class NewsDetailService {
    constructor(public baseService : BaseService) {}
   
    getNewsDetailData(id) {
        const url = NewMemoUrl.GET_MEMO_BY_ID;
        return this.baseService.getById(url, id);
    }
    updateNewsMemo(id, param){
        const url = NewMemoUrl.CONFIRM_MEMO.replace('{id}', id);
        return this.baseService.put(url, param)
    }
    downloadFile(id){
        const url = NewMemoUrl.DOWNLOAD_FILE;
        return this.baseService.getById(url, id);
    }
}


// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/centre/news-memo/new-detail.service.ts